import Alert from "@pathwright/ui/src/components/alert/Alert"
import ThemeBackground from "@pathwright/ui/src/components/background/ThemeBackground"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import Fullscreen, {
  FULLSCREEN_LAYER_OVERLAY
} from "@pathwright/ui/src/components/fullscreen/Fullscreen"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Portal from "@pathwright/ui/src/components/portal/Portal"
import Text from "@pathwright/ui/src/components/ui/Text"
import View from "@pathwright/ui/src/components/ui/View"
import useCanSyncPath from "@pathwright/web/src/modules/path/hooks/useCanSyncPath"
import { ConnectStores } from "lib/core/store"
import { useContext } from "react"
import styled from "styled-components"
import { PathContext } from "./PathProvider"

const StyledMessageContainer = styled(View.Primary)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
`

const StyledMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  h4 {
    margin-right: 0.5em;
  }
`

const StyledSubmitButton = styled(SubmitButton)`
  &:not(.SubmitButton--loading) {
    overflow: hidden;
  }
`

const StyledButtonContent = styled.div`
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  i {
    margin-left: 0.5em;
  }
`

const PathSync = ({ viewingAsLearner }) => {
  const { t } = useTranslate()
  const { path, syncPath, syncing, error } = useContext(PathContext)

  const canSyncPath = useCanSyncPath({
    path
  })

  // if needsSync, syncing is handled elsewhere
  const needsSync = path && !path.sync.synced
  const canSync = !needsSync && !viewingAsLearner && canSyncPath

  if (!syncing && !canSync) return null

  return (
    <Fullscreen
      layer={FULLSCREEN_LAYER_OVERLAY}
      background={syncing ? { overlay: "rgba(0,0,0,.6)" } : null}
      allowScroll={false}
    >
      <Portal portalElementID="alert">
        <StyledMessageContainer key="path-sync" padding>
          <StyledMessage>
            <Text.H4>{t("path.sync.new_updates")}</Text.H4>{" "}
            <StyledSubmitButton
              brand={false}
              styleType="primary"
              size="large"
              submitting={syncing}
              submitFailure={error}
              onClick={syncPath}
            >
              <ThemeBackground rounded />
              <StyledButtonContent>
                <span>{t("path.sync.update_path")}</span>
                <Pathicon icon="rocket" />
              </StyledButtonContent>
            </StyledSubmitButton>
          </StyledMessage>
          <Alert error={error} />
        </StyledMessageContainer>
      </Portal>
    </Fullscreen>
  )
}

PathSync.displayName = "PathSync"

const mapStateToProps = function (state, ownProps) {
  const { viewing_as_learner: viewingAsLearner } = state.pathStore.state
  return { viewingAsLearner }
}

const stores = [{ store: "path", watch: ["viewing_as_learner"] }]

export default ConnectStores(PathSync, stores, {}, mapStateToProps)
